import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { NavLink, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { RootState } from '@/store'
import LightLogo from '@/assets/images/freeze-color/logo.svg'
import SignalIcon from '@/assets/images/signal.svg'
import { MainHeader, Logo, BrandButton, LoginNav, SeperateLine, MySignalText } from './style'
import { UserAuth } from '@/utils/enum'
import I18nSelector from '../i18n-selector'
import UserMenu from '../user-menu'
import { SFButton, SFSVG } from '@otsofintech/sofinx-ui'
import { LANDING_VERSION } from '@/pages/landing/version'
import NoxBrandLogo from '@/pages/landing/nox/brand-logo'

const HeaderBar = () => {
  const { t } = useTranslation()
  const history = useHistory()

  const site = useSelector((state: RootState) => state.site)

  const isLogin = useSelector((state: RootState) => state.auth !== UserAuth.GUEST)
  const isLoginPage = useMemo(() => history.location.pathname === '/login', [history.location.pathname])

  // nox 版：整站都用 NOX 品牌
  // new 版（過渡）：只在 landing (/) 顯示 NOX 文字 logo、保留原 Meet 動作
  const isNoxVersion = LANDING_VERSION === 'nox'
  const isNewLandingBrand = history.location.pathname === '/' && LANDING_VERSION === 'new'
  const useNoxBrand = isNoxVersion || isNewLandingBrand

  const rawCtaLabel = site.hyperlinkContext || t('meet')
  const ctaLabel = useNoxBrand ? rawCtaLabel.replace(/SoFinX/gi, 'NOX') : rawCtaLabel

  const renderBrand = () => {
    if (isNoxVersion) {
      return (
        <BrandButton onClick={() => history.push('/')} aria-label='NOX'>
          <NoxBrandLogo compact showTagline={false}/>
        </BrandButton>
      )
    }
    return (
      <Logo onClick={() => history.push('/')} src={site.lightLogo} defaultSrc={LightLogo} width="93px" height="32px" />
    )
  }

  return (
    <MainHeader isLogin={isLogin}>

      {renderBrand()}
      {/* { site.hyperlinkHide === false && isLogin && <Meet href={site.hyperlinkUrl} target="_blank">{site.hyperlinkContext || t('meet')}</Meet> } */}
      { isLogin &&
      <NavLink to='/signal' style={{display: 'flex', alignItems: 'center', marginLeft: 'auto'}}>
        <SFSVG src={SignalIcon} width='24px' height='24px' color='primary' />
        <MySignalText level={1} fontWeight={600} color='primary' ml='6px'>{t('mySignal')}</MySignalText>
      </NavLink>}
      { isLogin &&
      <SeperateLine/>
      }
      <I18nSelector />
      <SeperateLine/>
      { !isLogin ?
        <>
          <LoginNav to={ isLoginPage ? '/register' : '/login' }>{t( isLoginPage ? 'register' : 'login')}</LoginNav>
          { site.hyperlinkHide === false && <SFButton ml="24px" themecolor="primary" onClick={() => useNoxBrand ? history.push('/register') : window.open(site.hyperlinkUrl, '__blank')}>{ctaLabel}</SFButton> }
        </> : null
      }
      { isLogin ? <UserMenu /> : null }
    </MainHeader>
  )
}

export default HeaderBar
